module.exports = __webpack_public_path__ + "img/Anhänger_kl_Boot.50cf9c1a.svg";